import { render, staticRenderFns } from "./UserShowRolesPermissionsTab.vue?vue&type=template&id=6fcfe9df"
import script from "./UserShowRolesPermissionsTab.vue?vue&type=script&lang=ts"
export * from "./UserShowRolesPermissionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports